import React from 'react';
import { List, Edit, Create, Show, SimpleShowLayout, ShowButton, DeleteButton,
    Datagrid, EmailField, TextField, FunctionField,
    EditButton, SimpleForm, TextInput } from 'admin-on-rest';

const ClientTitle = ({ record }) => {
    return <span>{record ? `${record.companyName}` : ''}</span>;
};

export const ClientShow = (props) => (
    <Show title={<ClientTitle />} {...props}>
        <SimpleShowLayout>
            <TextField label="Entreprise" source="companyName" />
            <EmailField source="email" />
            <FunctionField label="Nom" render={record => record.lastname ? `${record.lastname} ${record.firstname}` : ''} />
            <TextField source="phone" />
            <FunctionField label="Adresse" render={record => record.address ? `${record.address} ${record.address2 ? `${record.address2}` : ''} ${record.zipcode} ${record.city}` : ''} />
            <TextField source="BIC" label="BIC" />
            <TextField source="IBAN" label="IBAN" />
        </SimpleShowLayout>
    </Show>
);

export const ClientCreate = (props) => (
    <Create {...props}>
        <SimpleForm>
            <TextInput source="companyName" label="Entreprise" />
            <TextInput source="email" />
            <TextInput source="lastname" label="Nom" />
            <TextInput source="firstname" label="Prénom" />
            <TextInput source="phone" label="Numéro de téléphone" />
            <TextInput source="address" label="Adresse" />
            <TextInput source="address2" label="Complément d'adresse" />
            <TextInput source="zipcode" label="Code postal" />
            <TextInput source="city" label="Ville" />
            <TextInput source="BIC" label="BIC" />
            <TextInput source="IBAN" label="IBAN" />
        </SimpleForm>
    </Create>
);

export const ClientList = (props) => (
    <List title="Tous les clients" {...props}>
        <Datagrid>
            <TextField label="Entreprise" source="companyName" />
            <EmailField source="email" />
            <FunctionField label="Nom" render={record => record.lastname ? `${record.lastname} ${record.firstname}` : ''} />
            <TextField source="phone" label="Téléphone"/>
            <FunctionField label="Adresse" render={record => record.address ? `${record.address} ${record.address2 ? `${record.address2}` : ''} ${record.zipcode} ${record.city}` : ''} />
            <ShowButton />
            <EditButton />
            <DeleteButton />
        </Datagrid>
    </List>
);

export const ClientEdit = (props) => (
    <Edit {...props}>
        <SimpleForm>
            <TextInput source="companyName" label="Entreprise" />
            <TextInput source="email" />
            <TextInput source="lastname" label="Nom" />
            <TextInput source="firstname" label="Prénom" />
            <TextInput source="phone" label="Numéro de téléphone" />
            <TextInput source="address" label="Adresse" />
            <TextInput source="address2" label="Complément d'adresse" />
            <TextInput source="zipcode" label="Code postal" />
            <TextInput source="city" label="Ville" />
            <TextInput source="BIC" label="BIC" />
            <TextInput source="IBAN" label="IBAN" />
        </SimpleForm>
    </Edit>
);


// WEBPACK FOOTER //
// src/resources/clients.js